//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
export default {
  name: "Index",
  data() {
    return {
      activeName: 0,
      loginSrc: "",
      all: {
        appid: "",
        libVersion: "",
        projectname: "",
        domain: "",
        uid: "",
        desc: "",
        url: document.domain
      },
      previewQr: ""
    };
  },
  mounted() {
    axios.post(this.$appUrl+"/api/doLogin").then(data => {
      // console.log(data.data);
      if (data.data.success == true) {
        this.loginSrc = data.data.data;
        // this.all = data.data.all;
        this.activeName = 0;
        // this.activeName = 1;

        // 检测是否扫码登录成功;
        let setIn = setInterval(() => {
          axios
            .post(this.$appUrl+"/api/checkLoginStatus")
            .then(data => {
              // console.log(data.data);
              if (data.data.success == true) {
                // alert('扫码成功')
                this.activeName = 1;
                clearInterval(setIn);
              }
            });
        }, 1000);
      }
    });
  },
  methods: {
    postMsg() {
      const loading = this.$loading({
        lock: true,
        text: "代码提交中",
        spinner: "el-icon-loading",
        background: "rgb(0,0,0,0.66)"
      });
      axios
        .post(this.$appUrl+"/api/pushMiniApp", this.all)
        .then(data => {
          // console.log(data.data);
          loading.close();
          if (data.data.success == true) {
            this.previewQr = data.data.data;
            this.$message({
              message: "代码提交成功",
              type: "success"
            });
            this.activeName = 2;
          } else {
            this.$message.error(data.data.data);
          }
        });
    },
    jumpToWechat() {
      this.$confirm("确定前往微信公众平台提交审核?", "提示", {
        confirmButtonText: "前去审核",
        cancelButtonText: "重新上传",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "审核成功!"
          });
        })
        .catch(() => {
          this.activeName = 0;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/app.vue